import React from 'react'
import Text from '../../atoms/Text'
import { ReactComponent as Edit } from '../../../assets/icons/edit_green.svg'
import { ReactComponent as User } from '../../../assets/icons/user.svg'
import { useSelector } from 'react-redux'

const UserSummary = ({ onPressEdit = () => {} }) => {
  const { userDetails } = useSelector((s) => s.auth)

  return (
    <div className="flex flex-col gap-4 px-4 py-1">
      <div className="w-full flex flex-row items-center justify-between">
        <Text
          tag={'p'}
          variant={'title'}
          size={'medium'}
          className={'text-text-primary'}
        >
          Summary
        </Text>
        <button
          onClick={onPressEdit}
          className="flex flex-row items-center gap-[2px]"
        >
          <Text
            tag={'p'}
            variant={'label'}
            size={'large'}
            bold={'true'}
            className={'text-text-brand-tertiary'}
          >
            Edit
          </Text>
          <Edit className="min-h-4 min-w-4" />
        </button>
      </div>
      <div className="bg-WHITE p-4 rounded-4 flex flex-row gap-3 items-center">
        <User className="min-h-[52px] min-w-[52px]" />
        <div className="h-full flex flex-col justify-between">
          <Text
            tag={'p'}
            variant={'title'}
            size={'small'}
            className={'text-text-primary'}
          >
            {userDetails?.data?.name}
          </Text>
          <Text
            tag={'p'}
            variant={'label'}
            size={'small'}
            className={'text-text-quartenary'}
          >
            {userDetails?.data?.gender === 'M' ? 'Male' : 'Female'} | Age:{' '}
            {userDetails?.data?.patient_age}
          </Text>
          <Text
            tag={'p'}
            variant={'label'}
            size={'small'}
            className={'text-text-quartenary'}
          >
            {userDetails?.data?.country_code} {userDetails?.data?.contact_no}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default UserSummary
